import { useMediaQuery } from "react-responsive";

export function useMyMediaQuery() {
  const isDesktop = useMediaQuery({ minWidth: 1080 });
  const isTablet = useMediaQuery({ minWidth: 600, maxWidth: 1080 });
  const isMobile = useMediaQuery({ maxWidth: 600 });
  return { isDesktop, isTablet, isMobile };
}
